import React from 'react';
import { Button } from '@/components/ui/button';
import { NavigateFunction } from 'react-router-dom';

export const renderDeepDiveContent = (item: any, navigate: NavigateFunction) => {
  if (!item || !item.content) return <p className="bg-white p-4">No content available</p>;

  return (
    <div className="space-y-4 bg-white p-4">
      <div>
        <h3 className="font-medium">Reference:</h3>
        <p>{item.content.reference || 'N/A'}</p>
      </div>
      {item.content.commentary && (
        <div>
          <h3 className="font-medium">Commentary:</h3>
          <p className="whitespace-pre-line">{item.content.commentary}</p>
        </div>
      )}
      <Button
        onClick={() => navigate(`/deep-dive`)}
        className="mt-4"
      >
        Go to Deep Dive Tool
      </Button>
    </div>
  );
};
